import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class TokenGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const token = route.queryParamMap.get('token');

    if (token) {
      sessionStorage.setItem('auth_token', token);

      this.router.navigate(['/account/summary'], {
        queryParams: { token: null },
        queryParamsHandling: 'merge', 
        replaceUrl: true 
      });
    }

    return true;
  }
}
